import { useState, useCallback } from 'react';
import { ProyectoMock, proyectosMock as defaultMocks } from '../mocks/proyectos';

const STORAGE_KEY = 'ugpp_proyectos_v2';

const getInitialProyectos = (): ProyectoMock[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as ProyectoMock[];
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch { /* ignore */ }
  const initial = [...defaultMocks];
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(initial)); } catch { /* ignore */ }
  return initial;
};

export function useLocalProyectos() {
  const [proyectos, setProyectos] = useState<ProyectoMock[]>(getInitialProyectos);

  const addProyecto = useCallback((p: ProyectoMock) => {
    setProyectos(prev => {
      if (prev.some(x => x.codigo === p.codigo)) return prev;
      const updated = [...prev, p];
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(updated)); } catch { /* ignore */ }
      return updated;
    });
  }, []);

  const updateProyecto = useCallback((codigo: string, updates: Partial<ProyectoMock>) => {
    setProyectos(prev => {
      const updated = prev.map(p => p.codigo === codigo ? { ...p, ...updates } : p);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(updated)); } catch { /* ignore */ }
      return updated;
    });
  }, []);

  return { proyectos, addProyecto, updateProyecto };
}
